<template>
  <div class="home">

  Siamo spiacenti il gestionale è chiuso. 




  </div>
</template>

<script>


export default {
  name: 'inviato',
  data () {
    return {
      title:'',
      page: ''
    }
  },
  created(){
    var parent = this

    /*
    this.axios.get('page/home.html',{responseType: 'document'})
    .then(function (response) {
      parent.page = response.request.response.body.children.item(1).innerHTML
      
    })
    */
  },
  mounted(){
    
  },
  methods: {
  onNew(){
    var parent = this
    this.$abs.new().then(function (data) {
      parent.$abs.row.browsername = parent.$teras.browsername
      parent.$abs.row.browserversion = parent.$teras.browserversion
      parent.$abs.row.browsertime = parent.$teras.minutes
      parent.$abs.row.evento = parent.$teras.evento
      parent.$abs.row.lineeguida = false
      parent.$teras.affiliazioni = []
      parent.$teras.autori = []
      console.log("CARICATO NUOVO")
      console.log(parent.$abs.row)
    })
    console.log("DOPO NUOVO")
    console.log(this.$abs)
    console.log("DOPO NUOVO")

    /*
    this.$teras.absInviato = false
    this.$teras.preview = false
    this.$teras.minutes=0
    this.$teras.event.emit('setup',{newsession:true,evento:this.$teras.evento.id})
    */
  }
  }
}
</script>


<style scoped>
.combustion div.el-carousel__container {
  height: 440px !important;
  border:10px solid red;
  width: 500px;
}
.home a.btn{
  display:block;
  width: 100%;
  height: 3.8rem;
  color:#ffffff;
  text-align: center;
  line-height: 3.8rem;
  font-size: 1.8rem;
  font-weight: bold;
  background: darkred;
  border-color: darkred;
}.home a.main{
  display:block;
  font-size:2.3rem;
  text-align: center;
  color:darkred;
  font-weight: bold;
  padding:20px 0;
}
</style>



// WEBPACK FOOTER //
// Chiuso.vue?65e8bc56